import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CreateFormConfigDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FORMS_CONFIG } from "../domain";
import { ACTION_GET_FORMS_CONFIGS } from "../GetFormConfigs/useGetFormConfigs";

import { formsConfigApi } from "@api/services";
import { DOMAIN_FORMS, ACTION_GET_AVAILIBLE_FORM_TEMPLATES, roleGuard } from "@api";

export const ACTION_CREATE_FORM_CONFIG = "CREATE_FORM_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createFormConfig = async (req: CreateFormConfigDto): Promise<void> => {
  const response = await formsConfigApi.formsConfigControllerCreateFormConfig(req);

  return response.data;
};

export const useCreateFormConfig = (
  user: UserProfileDto | null,
): {
  createFormConfig: UseMutateFunction<void, Error, CreateFormConfigDto, unknown>;
  createFormConfigAsync: (req: CreateFormConfigDto) => Promise<void>;
  createFormConfigEnabled: boolean;
  isSuccessCreateFormConfig: boolean;
  isPendingCreateFormConfig: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS_CONFIG, ACTION_CREATE_FORM_CONFIG],
    mutationFn: enabled ? createFormConfig : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORMS_CONFIG, ACTION_GET_FORMS_CONFIGS],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FORMS, ACTION_GET_AVAILIBLE_FORM_TEMPLATES],
      });
    },
  });

  return {
    createFormConfig: mutate,
    createFormConfigAsync: mutateAsync,
    createFormConfigEnabled: enabled,
    isSuccessCreateFormConfig: isSuccess,
    isPendingCreateFormConfig: isPending,
  };
};
